import React, { useEffect, useRef, useState } from 'react';
import { Volume2, Square, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { useLang } from '../context/LangContext';
import { api, API } from '../lib/api';

const webSpeech = typeof window !== 'undefined' && 'speechSynthesis' in window;

const speakBrowser = (text, lang, onEnd) => {
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = lang === 'fr' ? 'fr-CA' : 'en-CA';
  u.rate = 0.95;
  const voice = window.speechSynthesis.getVoices().find((v) => v.lang.toLowerCase().startsWith(lang === 'fr' ? 'fr' : 'en'));
  if (voice) u.voice = voice;
  u.onend = onEnd; u.onerror = onEnd;
  window.speechSynthesis.speak(u);
};

export const ListenButton = ({ text, label, testId }) => {
  const { lang, t } = useLang();
  const [state, setState] = useState('idle');
  const audio = useRef(null);

  useEffect(() => () => { audio.current?.pause(); if (webSpeech) window.speechSynthesis.cancel(); }, []);
  if (!text) return null;

  const stop = () => { audio.current?.pause(); audio.current = null; if (webSpeech) window.speechSynthesis.cancel(); setState('idle'); };

  const play = async () => {
    setState('loading');
    try {
      const { data } = await api.post('/tts', { text, lang });
      const a = new Audio(`${API.replace(/\/api$/, '')}${data.url}`);
      audio.current = a;
      a.onended = () => setState('idle');
      a.onerror = () => setState('idle');
      await a.play();
      setState('playing');
    } catch {
      if (webSpeech) { setState('playing'); speakBrowser(text, lang, () => setState('idle')); }
      else setState('idle');
    }
  };

  const busy = state !== 'idle';
  return (
    <Button size="sm" variant="ghost" onClick={busy ? stop : play} aria-pressed={state === 'playing'} aria-label={busy ? t('Stop') : `${t('Listen')}${label ? `: ${label}` : ''}`} data-testid={testId || 'listen-btn'} className="gap-1.5 text-primary">
      {state === 'loading' ? <Loader2 className="w-4 h-4 animate-spin" /> : state === 'playing' ? <Square className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />} {busy ? t('Stop') : t('Listen')}
    </Button>
  );
};
